module.exports = __webpack_public_path__ + "59bacd9a898b33dc1550a80075971d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/team/Leadership_AlexP_0.jpg
// module id = 359
// module chunks = 0